(function() {

	'use strict';

	angular.module('Services').service('ReportingCompanyBySpendTableService', ReportingCompanyBySpendTableService);

	ReportingCompanyBySpendTableService.$inject = [
		'Shipments', 
		'Carrier', 
		'TableLiteFactory', 
		'CommonService', 
		'trackingStatusesConst', 
		'toastr',
		'$filter'
	];

	function ReportingCompanyBySpendTableService(
		Shipments, 
		Carrier, 
		TableLiteFactory, 
		CommonService, 
		trackingStatusesConst, 
		toastr,
		$filter
	) {

		let ReportingAccountBySpendTable = {
            tableName: 'ReportingCompanyBySpendTableService',
			config: {
				noPagination: false,
				noHeaders: false,
				noItemsView: false,
				noTableFooter: false,
			},
			headers: [{
				label: 'COMPANY NAME',
				viewName: 'companyName',
				filterName: 'companyName',
				filter: {
					type: 'text',
					class: 'bba-ref-no',
					placeholder: 'Search',
					onSubmit: function(header) {
						sendRequest(evaluateFilter(header));
					}
				},
				//headerFn: ()=>{sort(this.filterName)}
				headerFn: function(){
					sort(this.filterName);
				}
			}, {
				label: 'MONTH',
				viewName: 'amountMonth',
				/*filter: {
					type: 'inputDropdown',
					class: 'bba-ref-no',
					placeholder: 'Search',
					items: [{
						viewName: 'Month 1'
					}, {
						viewName: 'Month 2'
					}],
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}*/
			}, {
				label: 'MONTH LAST YEAR',
				viewName: 'comparableMonthLastYear',
				/*filter: {
					type: 'text',
					class: 'bba-ref-no',
					placeholder: 'Search',
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}*/
			}, {
				label: 'YEAR',
				viewName: 'amountYear',
				/*filter: {
					type: 'inputDropdown',
					class: 'bba-ref-no',
					placeholder: 'Search',
					items: [{
						viewName: 'Test'
					}, {
						viewName: 'Test2'
					}],
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}*/
			}, {
				label: 'LAST YEAR',
				viewName: 'comparableYear',
				/*filter: {
					type: 'inputDropdown',
					class: 'bba-ref-no',
					placeholder: 'Search',
					items: [{
						viewName: 'Test'
					}, {
						viewName: 'Test2'
					}],
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}*/
			}],
			data: []
		}
        const tableActions = new TableLiteFactory(ReportingAccountBySpendTable,
            {
                serviceCallback: Shipments.getAccountBySpend,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,asc'
                }
            }
        );
		let sort = tableActions.sort;
		let evaluateFilter = tableActions.evaluateFilter;
		let sendRequest = tableActions.sendRequest;
		let activeFilters = tableActions.activeFilters;

		function buildTableData(data, pagination, filters) {
			/*** START - Building of Data ***/
            if(!data)
                return ReportingAccountBySpendTable;
            tableActions.initializeTableData(data);
			angular.forEach(data.content, function(val) {
				val.serviceId = val.serviceDetails ? val.serviceDetails.serviceName : 'N/A';
				val.titleLogo = {
					type: 'logotype',
					imgSrc: CommonService.isContainLogo(val)
				};
				val.companyName = val.company ? val.company.name : 'N/A';
				val.comparableMonthLastYear = $filter("bbaCurrency")(val.comparableMonthLastYear, val.currency);
				val.amountMonth = $filter("bbaCurrency")(val.amountMonth, val.currency);
				val.amountYear = $filter("bbaCurrency")(val.amountYear, val.currency);
				val.comparableYear = $filter("bbaCurrency")(val.comparableYear, val.currency);

				val.href = '/reporting/office-by-spend?companyId=' + val.company.id + "&companyName=" + val.company.name;

                ReportingAccountBySpendTable.data.push(val);
			});
		};
		return ReportingAccountBySpendTable;
	};
})();



// WEBPACK FOOTER //
// ./js/services/tables/ReportingCompanyBySpendTableService.js